import { render, staticRenderFns } from "./Page-Team.vue?vue&type=template&id=9e91d5c2&"
import script from "./Page-Team.vue?vue&type=script&lang=js&"
export * from "./Page-Team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports